import appCorporate from "../../views/appCustomers/corporate.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "corporate/:id";
  const params = [
    "page",
    "limit",
    "start_date",
    "end_date",
    "date",
    "time",
    "office_location",
    "status",
  ];
  $stateProvider.state("corporate", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appCorporate,
      },
    },
    data: { title: "Corporate" + constants.titleBase },
    reloadOnSearch: false,
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/corporate/corporate.urls.js